var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-2 ml-md-5 ml-sm-2 mr-4 pb-3" },
    [
      _vm.items.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _c(
        "time-line",
        { staticClass: "mt-4" },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            { key: `item-index-${index}` },
            [
              _c(
                "time-line-item",
                {
                  staticClass: "custom-time-line rounded",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function() {
                          return [
                            _c("em", {
                              staticClass: "radius",
                              class: `fas fa-${_vm.getIconStatus(
                                item.statusId
                              )}`
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "date",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "date-container" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-bold fulldate"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("date")(item.createDate)) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-12 font-weight-normal hour"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("hour")(item.createDate)) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("div", { staticClass: "row py-4 mx-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-sm-12 border-right" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "color-gray-12 font-weight-bold mb-2"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.statusMainDescription(item.statusId)
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-gray-6 font-14 font-weight-normal"
                          },
                          [_vm._v(" Estatus: ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("em", {
                              staticClass: "fas fa-circle mr-2",
                              class: `font-12 color-${_vm.getColorStatus(
                                item.statusId
                              )}`
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-normal"
                              },
                              [_vm._v(" " + _vm._s(item.statusName) + " ")]
                            )
                          ]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "col-md-9" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col ml-5 ml-md-5 ml-sm-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-gray-6 font-14 font-weight-normal"
                            },
                            [_vm._v(" Usuario: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [_vm._v(" " + _vm._s(item.createUserName) + " ")]
                          )
                        ]),
                        _vm.viewComments(item.comments)
                          ? _c(
                              "div",
                              { staticClass: "col ml-5 ml-md-5 ml-sm-0" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-gray-6 font-14 font-weight-normal"
                                  },
                                  [_vm._v(" Descripción: ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-black font-16 font-weight-normal"
                                  },
                                  [_vm._v(" " + _vm._s(item.comments) + " ")]
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        }),
        0
      ),
      _vm.pageCount > 1
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center mt-3"
            },
            [
              _c("action-button", {
                staticClass: "btn-see-more",
                attrs: {
                  i: "fas fa-chevron-down",
                  text: "Ver más",
                  variant: "outline-success rounded-pill px-5"
                },
                on: { click: _vm.onLoadMoreHandler }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }